import { motion, AnimatePresence } from 'framer-motion';
import { ShieldAlert, X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * ImpersonationBanner
 * Shown as a fixed top bar whenever an admin is impersonating another user.
 * Always visible — cannot be dismissed without stopping impersonation.
 */
const ImpersonationBanner = () => {
    const { impersonating, stopImpersonation } = useAuth();

    return (
        <AnimatePresence>
            {impersonating && (
                <motion.div
                    initial={{ y: -56, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -56, opacity: 0 }}
                    transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                    className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-between px-4 py-2.5"
                    style={{
                        background: 'linear-gradient(90deg, #dc2626, #b91c1c)',
                        boxShadow: '0 4px 20px rgba(220,38,38,0.4)',
                    }}
                >
                    <div className="flex items-center gap-2.5">
                        <ShieldAlert className="w-4 h-4 text-white flex-shrink-0" />
                        <p className="text-white text-xs font-semibold">
                            Modalità impersonificazione attiva —{' '}
                            <span className="font-bold">
                                {impersonating.userProfile?.name || impersonating.userProfile?.email}
                            </span>
                            {' '}({impersonating.userProfile?.role})
                        </p>
                    </div>
                    <button
                        onClick={stopImpersonation}
                        className="flex items-center gap-1.5 px-3 py-1 rounded-lg bg-white/20 hover:bg-white/30 text-white text-xs font-semibold transition-all border border-white/30"
                    >
                        <X className="w-3.5 h-3.5" />
                        Esci
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default ImpersonationBanner;
